import type { PropsWithChildren } from 'react';

import { Link } from '@remix-run/react';
import cx from 'classnames';

type Props = PropsWithChildren<{ slug: string; className?: string }>;

const PostLinkHelper = ({ slug, children, className }: Props) => {
  return (
    <Link to={`/p/${slug}`} prefetch="intent" className={cx(className)}>
      {children}
    </Link>
  );
};

export default PostLinkHelper;
